import { Option } from "@/common/types/option";
import { SearchIcon } from "lucide-react";
import Accordion from "../Accordion";
import TextField from "../TextField";

interface SheetFiltersItemProps {
  instantSearch?: string;
  setSearch?: (value: string) => void;
  options?: Option[];
  label: string;
  value: string | null | undefined;
  onChange: (value: Option | null) => void;
}

const SheetFiltersItem = ({
  instantSearch,
  setSearch,
  options,
  label,
  value: currentValue,
  onChange,
}: SheetFiltersItemProps) => {
  return (
    <Accordion
      className="rounded-none p-0"
      triggerClassName="px-4"
      contentClassName="bg-black-900 overflow-y-auto max-h-[232px]"
      head={
        <div className="flex items-center gap-2">
          <p className="font-light text-sm italic">
            {label}
          </p>
        </div>
      }
      body={(
        <div className="pt-4 px-4">
          {setSearch && (
            <TextField
              variant="filter"
              LeftIcon={<SearchIcon size={14} />}
              placeholder="Pesquisar"
              className="mb-2"
              value={instantSearch}
              onChange={(e) => setSearch(e.currentTarget.value)}
            />
          )}

          {options?.map(({ label, value }) => (
            <div
              key={value}
              className="flex items-center gap-x-2 py-2 cursor-pointer"
              onClick={() => onChange(value ? { label, value } : null)}
            >
              {currentValue === value && (
                <div className="w-1 h-5 shrink-0 bg-blue-800 rounded-full" />
              )}

              <p className="font-light text-sm">
                {label}
              </p>
            </div>
          ))}
        </div>
      )}
    />
  );
}

export default SheetFiltersItem;
